import { Button, Modal, useMantineTheme } from '@mantine/core';
import React from 'react';
import { ConfirmPopUpProps } from '../../../../../../types/types';
import { themeProvider } from '../../../../../style/utils';
import "./confirmPopUp.css";


export function ConfirmPopUp(props : ConfirmPopUpProps){

  const theme = useMantineTheme();

  function confirmDelete(){
    props.deleteQueryCard();
    props.setOpenConfirmModal(false);
  }
  
     return(<div>
         <Modal
        style={{ zIndex: 100000}}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        opened={props.openConfirmModal}
        onClose={() => props.setOpenConfirmModal(false)}
        radius="lg"
        size="500px"
      >
        <div className="confirmPopUp-container">
        <h2>{props.message}</h2>
        <Button sx={themeProvider} color="teal" variant="outline" onClick={confirmDelete}> {props.buttonPlaceHolder}</Button>
        </div>
      </Modal>
     </div>) 
}

